import React from 'react';
import InnerAsyncSelect from 'react-select/lib/Async';
import {withStyles} from '@material-ui/core/styles';
import components from './components';
import styles from './styles';
import i18n from "../../../i18n";
import {TextField} from "@material-ui/core";
import FormField from "../FormField";

const AsyncSelect = ({classes, theme, fullWidth, label, name,  multiple, error, touched, ...props}) => {
    const selectStyles = {
        input: base => ({
            ...base,
            color: theme.palette.text.primary,
            '& input': {
                font: 'inherit',
            },
        }),
    };

    // handles (nested) object validation.
    // takes the first object value and displays it.
    // example: ContractForm.js @ validationSchema - property craft
    if(typeof error === 'object') {
        error = error[Object.keys(error)[0]];
    }

    if (props.disabled || props.readOnly) {
        return (
            <FormField
                label={label}
                fullWidth={fullWidth}
                error={touched && !!error}
                helperText={touched && error}
                InputLabelProps={{
                    shrink: true
                }}
                {...{disabled: props.disabled, readOnly: props.readOnly}}
                value={props.value && ( props.value.label || props.value )}
            />
        );
    }

    return (
        <InnerAsyncSelect
            id={name}
            name={name}
            classes={classes}
            styles={selectStyles}
            components={components}
            textFieldProps={{
                label,
                fullWidth,
                error: touched && !!error,
                helperText: touched && error,
                InputLabelProps: {
                    shrink: true,
                },
            }}
            isMulti={multiple}
            placeholder={label}
            noOptionsMessage={() => i18n.get('default.select.noOptions')}
            loadingMessage={() => i18n.get('default.select.loading')}
            {...props}
        />
    );
};

AsyncSelect.defaultProps = {
    fullWidth: true,
};

export default withStyles(styles, {withTheme: true})(AsyncSelect);
